export function getSlideId() {
  if (window.tnsId === undefined) {
    window.tnsId = 1;
  } else {
    window.tnsId++;
  }
  return 'tns' + window.tnsId;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/getSlideId.js
// module id = 73
// module chunks = 0 1